import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
 
import {
  getCsvFile,
  getMultiCsvFile,
} from "../../store/onboarding/actions";
 
import DataFileReader from "../../components/common/file-reader/FileReader";
import { toastr } from "react-redux-toastr";

const REQUIRED_HEADERS = ["Student ID", "First Name", "Last Name"];

interface FileUploadHandlerProps {
    uploadCsvFile: (fileName: string, columns: string[], rows: any[], fileInputKey?: number, isFromStudentRoster?: boolean) => void;
    uploadMultipleCsvFile: (fileInputKey: number, ...args: any[]) => void;
  }
  const FileUploadHandler: React.FC<FileUploadHandlerProps> = ({
    uploadCsvFile,
    uploadMultipleCsvFile,
  }) => {
 
  return (
<DataFileReader
      uploadCsvFile={(fileName: string, columns: string[], rows: any[], fileInputKey?: number) => {
        if (!rows || !rows.length) {
            toastr.error("Failed", `The uploaded file is empty.`);
          return;
        }
       
        const firstRow = rows[0];
        if (typeof firstRow !== "object" || firstRow === null) {
            toastr.error("Failed", "Invalid file structure.");
            return;
        }
        const rawHeaders = Object.keys(firstRow);
        const headers = rawHeaders.filter((h) => h && h.trim().length > 0);
        const RequiredHeadersMissing = REQUIRED_HEADERS.some((requiredHeader) => {
          return !headers.some((header) => header.trim().toLowerCase() === requiredHeader.toLowerCase());
        });

        if (headers.length < 3 || RequiredHeadersMissing) {
          toastr.error(
            "Failed",
            `Required columns not found. Make sure your file includes the following columns: ${REQUIRED_HEADERS.join(", ")}.`
          );
          return;
        }
       
        uploadCsvFile(fileName, columns, rows, fileInputKey, true);
      }}
      uploadMultipleCsvFile={uploadMultipleCsvFile}
    />
  );
};
const mapDispatchToProps = (dispatch: Dispatch) =>
    bindActionCreators(
      {
        uploadCsvFile: getCsvFile,
        uploadMultipleCsvFile: getMultiCsvFile,
      },
      dispatch
    );
export default connect(null, mapDispatchToProps)(FileUploadHandler);